import { AccountingSheetInterface } from '@/types/AccountingSheet';
import { Pretension } from '@/types/Pretension';
import { accountingSheet } from '@/utils/config';
import {
  Vue,
  Component,
} from 'vue-property-decorator';

type DownloadDocumentsInterface = {
  link: string;
  type: string | undefined;
  name: string | undefined;
}

@Component
export default class DocumentsMixin extends Vue {
  private documents: DownloadDocumentsInterface[] = [];

  public get downloadDocuments(): DownloadDocumentsInterface[] {
    return this.documents;
  }

  private getNameFromS3ObjectName(objectName: string): string {
    const splitted = objectName.split('/');
    return splitted[splitted.length - 1];
  }

  public getDocumentType(type: string): string {
    const map = new Map([
      ['sheet', 'Лист'],
      ['sheet_archive', 'ZIP'],
      ['act', 'Акт'],
      ['upd', 'УПД'],
      ['account', 'Счет'],
      ['default', 'Doc'],
    ]);
    const name = map.get(type) !== undefined ? map.get(type) : map.get('default');
    return name || '';
  }

  private buildDownloadLink(bucket: string, objectName: string): string {
    const { linkConstructorForDownload } = accountingSheet.downloadFiles;
    const authToken = localStorage.getItem('authToken');
    if (authToken !== null) {
      return linkConstructorForDownload
        .replace('{authorizationToken}', authToken)
        .replace('{bucket}', bucket)
        .replace('{file}', objectName);
    }

    console.error('Authorization token is null, check local storage');
    return '';
  }

  public makeDocumentsLinks(object: Pretension | AccountingSheetInterface) {
    this.documents = [];
    object.documents.filter((item) => item.type !== null).forEach((item) => {
      this.documents.push({
        link: this.buildDownloadLink(item.bucket, item.objectName),
        type: this.getDocumentType(item.type),
        name: this.getNameFromS3ObjectName(item.objectName),
      });
    });
  }
}
